/* eslint-disable */
/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2026-01-15 10:59:46
 */
import sensors from 'sa-sdk-javascript'
import pageleave from 'sa-sdk-javascript/dist/web/plugin/pageleave/index.es6.js'
import './abtest.esm.min.js'
import './webPopup.esm.min.js'
import desktopLib from './desktopLib'
import CONFIG from '../constants/config'

const serverURL =
  __RELEASE_STAGE__ === 'production'
    ? 'https://sareport.xhey.top/sa?project=ACamera'
    : 'https://sareport.xhey.top/sa?project=default'
const abTestUrl =
  __RELEASE_STAGE__ === 'production'
    ? 'https://abtest-tx-beijing-01.saas.sensorsdata.cn/api/v2/abtest/online/results?project-key=0E6053C30A799D63EFA48959776B2EE2EDC81359'
    : 'https://abtest-tx-beijing-01.saas.sensorsdata.cn/api/v2/abtest/online/results?project-key=EE39C73914ED208E6EBE24A7333CAF5C3FE2E89D'

const reportUrl =
  __BUILD_ENV__ === 'staging'
    ? 'https://staging.xhey.top'
    : 'https://test.xhey.top'
const webPopupServerUrl =
  __RELEASE_STAGE__ === 'production'
    ? 'https://xiaoheikeji.sfn-tx-beijing-01.saas.sensorsdata.cn/api/v2'
    : 'https://xiaoheikeji.sfn-tx-beijing-01.saas.sensorsdata.cn/api/v2'

sensors.init({
  server_url: serverURL,
  //heatmap_url神策分析中点击分析及触达分析功能代码，代码生成工具会自动生成。如果神策代码中 `sensorsdata.min.js` 版本是 1.9.1 及以上版本，这个参数必须配置，低于此版本不需要配置。
  // heatmap_url: "https://cdn.jsdelivr.net/npm/sa-sdk-javascript@1.14.7/heatmap.min.js",
  //web_url 神策分析中点击分析及触达分析功能会用到此地址，代码生成工具会自动生成。如果神策后台版本及 `sensorsdata.min.js` 均是 1.10 及以上版本，这个参数不需要配置。
  // web_url:"神策分析后台地址",
  heatmap: {
    //是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
    //需要 JSSDK 版本号大于 1.7
    clickmap: 'default',
    //关闭自动采集的触达注意力图，改用插件形式
    scroll_notice_map: 'not_collect'
  },
  is_track_single_page: function () {
    return true
  },
  show_log: false
})

// 使用 pageleave 插件进行页面浏览时长追踪
sensors.use(pageleave, {
  custom_props: {
    // 可以添加自定义属性
    tracking_method: 'plugin'
  },
  heartbeat_interval_time: 5, // 心跳间隔时间（秒）
  max_duration: 24 * 60 * 60, // 最大持续时间（秒）
  isCollectUrl: function (url) {
    return true
  }
})

sensors.registerPage({
  isDesktop: desktopLib.isDesktop,
  clientVersion: desktopLib?.clientInfo?.version,
  // 重构版标识：全量后新旧版共用主域名，靠该公共属性区分神策事件来自重构版还是旧版（旧版不带此属性）
  webEdition: 'refactor2026'
})

sensors.quick('autoTrack')

const abtest = sensors.use('SensorsABTest', {
  url: abTestUrl
})

const parsePlaceValue = () => {
  let pathname = window.location.pathname
  // 如果url是/data/statistics，包含dataStatisticsType，则返回dataStatisticsType
  const url = new URL(window.location.href)
  const dataStatisticsType =
    url.searchParams.get('dataStatisticsType') || 'dataStatisticStaffManage'
  if (pathname === '/data/statistics' && dataStatisticsType) {
    return dataStatisticsType
  }
  if (pathname === '/photo/all' || pathname === '/' || pathname === '/photo') {
    return 'allPhoto'
  } else if (pathname === '/attendance/daily') {
    return 'attendanceDaily'
  } else if (pathname === '/attendance/period') {
    return 'attendancePeriod'
  } else if (pathname === '/watermark/data') {
    return 'watermarkData'
  } else if (pathname === '/watermark/list') {
    return 'watermarkList'
  } else if (pathname === '/watermark/editor') {
    return 'watermarkEditor'
  } else if (pathname === '/photo/location') {
    return 'photoLocation'
  } else if (pathname === '/member/location') {
    return 'memberLocation'
  } else if (pathname === '/pathway') {
    return 'pathway'
  } else if (/\/photo\/folder\/add\/\d+/.test(pathname)) {
    return 'photoFolder'
  } else if (/^\/photo\/picker\??[^\/]*$/.test(pathname)) {
    return 'photoPicker'
  } else {
    return pathname
  }
}

const sensorsRole = (myRole) => {
  return myRole === 0
    ? 'member'
    : myRole === 3
      ? 'departmentManager'
      : myRole === 2
        ? 'manager'
        : myRole === 1
          ? 'chiefManager'
          : ''
}

const sensorsVipLevel = (group) => {
  // group 已经是普通对象
  const isVip = group?.isVip || group?.is_vip
  const vipKind = group?.vipInfo?.vip_kind || group?.vip_info?.vip_kind

  if (!isVip) {
    return 'nonvip'
  }

  switch (vipKind) {
    case CONFIG.VIP_KIND.VIP: // 1
      return 'vip'
    case CONFIG.VIP_KIND.SVIP: // 2
      return 'svip'
    case CONFIG.VIP_KIND.VVIP: // 3
      return 'vvip'
    case CONFIG.VIP_KIND.EVIP: // 4
      return 'evip'
    default:
      return 'nonvip'
  }
}

const originalTrack = sensors.track as (
  event: string,
  params?: object,
  callback?: any
) => void

sensors.track = (event: string, params?: object, callback?: any) => {
  if (__BUILD_ENV__ === 'staging') {
    fetch(`${reportUrl}/next/point/create`, {
      method: 'POST',
      body: JSON.stringify({
        event,
        params,
        versioncode: __VERSION_CODE__ && Number(__VERSION_CODE__)
      })
    })
  }

  originalTrack.call(sensors, event, params, callback)
}

const registeWebPopup = (
  callback: (data: { planId: any; name: any; content: any }) => void = () => {}
) => {
  sensors.use('WebPopup', {
    api_base_url: webPopupServerUrl,
    popup_campaign_listener: {
      shouldStart: () => true,
      onStart: (data) => {
        console.log('神策弹窗 ============== ', data)

        const content = JSON.parse(data.content).reduce(
          (res, { name, value }) => {
            if (name === 'toView') {
              value = JSON.parse(value)
            }

            res[name] = value

            return res
          },
          {}
        )

        callback({
          planId: data.planId,
          name: data.name,
          content
        })
      },
      onFailed: function (SFCampaign, errorCode, errorMessage) {
        console.log('神策弹窗 onFailed ======= ', {
          SFCampaign,
          errorCode,
          errorMessage
        })
      },
      onEnd: function (SFCampaign) {
        console.log('神策弹窗 onEnd ======== ', {
          SFCampaign
        })
      }
    }
  })
}

export {
  abtest,
  sensorsRole,
  sensorsVipLevel,
  parsePlaceValue,
  registeWebPopup
}

export default sensors
